import React from 'react';
import { ClickAwayListener, List } from '@mui/material';

const PopperContent = ({
                         onClickAway,
                         onMouseEnter,
                         onMouseLeave,
                         items,
                       }: {
  onClickAway: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  items: React.ReactNode[];
}) => {
  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <div
        className="popover-actions"
        style={{
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '4px',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <List
          sx={{
            '& .MuiListItemIcon-root': {
              minWidth: '34px',
              color: '#256861',
            },
            p: '5px',
          }}
        >
          {items}
        </List>
      </div>
    </ClickAwayListener>
  );
};

export default PopperContent;
